import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { APIService } from 'src/app/core/api/general.service';
import { LayoutService } from 'src/app/layout/services/layout.service';
import { DashboardService } from '../../dashboard/services/dashboard.service';
import { ItineraryService } from '../../search-result/services/itinerary.service';
import { PnrInfo, SearchForm } from 'src/app/core/models/itinerary.model';
import { User } from 'src/app/core/models/models';
import { VoluntaryChangeService } from 'src/app/voluntary-change/services/voluntary-change.service';
import { ReissueService } from 'src/app/reissue/services/reissue.service';
import { ReportLogService } from 'src/app/shared/services/report-log.service';
import { OptionType } from 'src/app/core/enums/enums';
import { DashboardComponent } from 'src/app/dashboard/containers/dashboard/dashboard.component';
import { PnrState } from '../reducers/pnr.reducer';

@Injectable()
export class ItineraryGuard implements CanActivate {
  user: User;
  localSearchResultState = 'searchResult';

  constructor(
    private api: APIService,
    private itineraryService: ItineraryService,
    private dashboardService: DashboardService,
    private voluntaryChangeService: VoluntaryChangeService,
    private layoutService: LayoutService,
    private router: Router,
    private reissueService: ReissueService,
    private reportLog: ReportLogService
  ) {}

  loadPnrInfo(form: SearchForm) {
    const prevTransactionID = (
      JSON.parse(
        window.localStorage.getItem(this.localSearchResultState)
          ? window.localStorage.getItem(this.localSearchResultState)
          : ''
      ) as PnrState
    )?.pnrInfo?.transactionId;

    if (form.gds === null) {
      this.router.navigate(['/dashboard']);
      return of(false);
    }

    return this.getInfo(form, prevTransactionID).pipe(
      map((response) => {
        this.reissueService.clearReissue();
        this.layoutService.dispatchChangeBreadcrumb(response.code, 'itinerary');
        this.itineraryService.dispatcPnrInfoSuccess(response);
        this.dashboardService.dispatchLoadPnrSuccess();
        this.voluntaryChangeService.dispatchStoreLoadingPenalties();
        this.api
          .getPenaltiesFareBasis({
            ...form,
            passengers: response.passengers.map((passenger) => ({
              ticketNumber: passenger?.ticket?.number
            }))
          })
          .subscribe((penaltyFareBasis) => {
            this.voluntaryChangeService.dispatchStorePenaltiesRequestExchange(penaltyFareBasis);
          });
        DashboardComponent.isFirstSearch;
        DashboardComponent.isFirstSearch = false;
        return !!response;
      }),
      catchError((response) => {
        this.dashboardService.dispatchLoadPnrFail(response.error);
        this.router.url.includes('integrations')
          ? this.router.navigate(['integrations/error'])
          : this.router.navigate(['/dashboard']);
        DashboardComponent.isFirstSearch && this.reportLog.Search(OptionType.NA);
        DashboardComponent.isFirstSearch = false;
        return of(false);
      })
    );
  }

  getInfo(form: SearchForm, prevTransactionID: string): Observable<PnrInfo> {
    return form.searchType == 'tkt'
      ? this.api.getPnrInfoByTKT(form)
      : this.api.getPnrInfo(form.pnr, form.gds, form.bookingCode, prevTransactionID, false);
  }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.loadPnrInfo({ ...route.queryParams } as SearchForm);
  }
}
